function HideInRoutes() {
  return [];
}

export default HideInRoutes;
